import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Observable, Subscription } from 'rxjs';
import { AppLayoutComponent } from '../layouts/app-layout/app-layout.component';
import {
  AuthService,
  NotificationService,
  SefService,
  Tutorial,
} from '@kodit/core/services';
import { CoreService } from '../core-service';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import {
  GetKorisnikTenantAccessResponse,
  GetNotifikacijaKorisnikaListQuery,
  IGetSefHealthStatusResponse,
  INotifikacijaKorisnikaDto,
  IResultOfApiMenadzmentDto,
  Medij,
  MojaFirmaClient,
  NotifikacijeClient,
} from '@kodit/core/data-api';
import { NavigationEnd, Router } from '@angular/router';
import { RacunTutorialsService } from '@kodit/core/core-ui';
import { ProgressItem, ProgressService } from '../progress.service';
import { TopbarService } from './topbar.service';

export const colors = [
  '#1abc9c',
  '#2ecc71',
  '#3498db',
  '#9b59b6',
  '#34495e',
  '#16a085',
  '#27ae60',
  '#2980b9',
  '#8e44ad',
  '#2c3e50',
  '#f1c40f',
  '#e67e22',
  '#e74c3c',
  '#95a5a6',
  '#f39c12',
  '#d35400',
  '#c0392b',
  '#bdc3c7',
  '#7f8c8d',
  '#5DDEA3',
  '#FF5959',
];

@Component({
  selector: 'kodit-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  /** Subscription */
  private _subs: Subscription = new Subscription();

  /** Constants */
  maloprodaja_unos_url = '/maloprodaja/fiskalni/unos';

  /** Props */
  private intervalId: number | null = null;

  items: MenuItem[] = [];
  korisnikTenantAccesses$: Observable<GetKorisnikTenantAccessResponse>;
  name: string;
  email: string;
  isTrial: boolean;
  subDaysLeftText: string;
  notifikacijeKorisnika: INotifikacijaKorisnikaDto[] = [];
  isSefActiveDto: IGetSefHealthStatusResponse;
  tutorijali: Tutorial[] = [];
  progresses: ProgressItem[] = [];
  filters!: GetNotifikacijaKorisnikaListQuery;
  apiKey: string | null = null;
  jeRegos: boolean = false;

  /** Conditional props */
  shouldDisplayRacunYearFilter = true;
  shouldDisplayFiskalnaKasaStavkeRacunaTitle = false;

  /** I/O */
  @Input() companyMenuActive: boolean;
  @Output() onCompanyMenuClick = new EventEmitter<any>();

  constructor(
    private _authService: AuthService,
    public appLayout: AppLayoutComponent,
    public _coreService: CoreService,
    private _notificationClient: NotifikacijeClient,
    private _notificationService: NotificationService,
    private _router: Router,
    private _sefService: SefService,
    private _racunTutorialsService: RacunTutorialsService,
    private _progressService: ProgressService,
    private _mojaFirmaClient: MojaFirmaClient,
    private service: TopbarService
  ) {
    this._detectPageRefresh();
  }

  ngOnInit() {
    this._subs.add(
      this._mojaFirmaClient
        .getApiMenadzment()
        .subscribe((res: IResultOfApiMenadzmentDto) => {
          if (res && res.data && res.data.apiKeySEF) {
            this._sefService.setHasSefKey = true;
          } else {
            this._sefService.setHasSefKey = false;
            this._sefService.setIsSefActive = {
              isActive: null,
              background: null,
            };
          }
        })
    );

    this._subs.add(
      this._mojaFirmaClient.getMedij().subscribe((res) => {
        if (res.data == Medij.REGOS) {
          this.jeRegos = true;
        }
      })
    );

    this._subs.add(
      this._authService.getPackagesChanged.subscribe(() => {
        this.isTrial = this._authService.getIsTrial;
      })
    );

    this.filters = new GetNotifikacijaKorisnikaListQuery({
      pageNumber: 0,
      pageSize: 10,
      samoNeprocitane: true,
    });
    this._loadNotifications();
    //this.prepareUserInfo();
    this._notificationsSub();
    this._subs.add(
      this._authService.getUserChanged.subscribe((result) => {
        if (result) {
          this.prepareUserInfo();
        }
      })
    );
    this._subs.add(
      this._sefService.getIsSefActive.subscribe(
        (sefHealth: IGetSefHealthStatusResponse) => {
          this.isSefActiveDto = sefHealth;
          // if (!sefHealth.background) {
          //   this._afterLoginService.getDataAfterLogin();
          // }
        }
      )
    );
    // this._subs.add(
    //   this._fiskalniService.getEsdcCardStatus.subscribe(
    //     (cardStatus: EsdcCardStatusChangeNotification) => {
    //       this.esdcCardStatusDto = cardStatus;
    //     }
    //   )
    // );
    this.loadTutorijals(this._router.url);
    this.loadProgresses();
    this.routeChange();

    //this.getTutorials();
    this._subs.add(
      this._router.events.subscribe((res) => {
        if (res instanceof NavigationEnd) {
          this.shouldDisplayFiskalnaKasaStavkeRacunaTitle =
            res.url === this.maloprodaja_unos_url;
        }
      })
    );

    // this._subs.add(
    //   this._sefService.getHasSefKey
    //     .pipe(distinctUntilChanged())
    //     .subscribe(res => {
    //       if (res) {
    //         this._sefService.startSefHealthCheck();
    //       } else {
    //         this._sefService.stopSefHealthCheck();
    //       }
    //     }));
  }

  ngOnChanges(): void {
    this._loadNotifications();
    //this.handleOznaciKaoProcitano();
  }

  ngAfterViewInit(): void {
    this.prepareUserInfo();
  }

  loadProgresses() {
    this._subs.add(
      this._progressService
        .getProgresses()
        .subscribe((progresses: ProgressItem[]) => {
          this.progresses = progresses;
        })
    );
  }

  logOff() {
    this._authService.logout();
  }

  // handleOznaciKaoProcitano() {
  //   this._subs.add(
  //     this._client
  //       .readAllNotificationsKorisnika(
  //         new ReadAllNotificationsComand({
  //           notifikacijeIds: this.notifikacijeKorisnika
  //             .map((x) => x.id)
  //             .slice(0, 5),
  //         })
  //       )
  //       .subscribe((res) => {
  //         if (res.succeeded) {
  //           location.reload();
  //         }
  //       })
  //   );
  // }

  openPodesavanjaSidebar() {
    this.service.showPodesavanjaSidebar();
  }

  openNotifikacijeSidebar() {
    this.service.showNotifikacijeSidebar();
  }

  openProfileSidebar() {
    this.service.showProfileSidebar();
  }

  gotToNotifikacije() {
    this._router.navigate(['/notifikacije']);
  }

  goToArhivskaPodesavanja() {
    this._router.navigate(['/podesavanja/arhivska-knjiga']);
  }

  goToPretplataPage() {
    this._router.navigate(['pretplata', 'placanja']).then();
  }

  private loadTutorijals(route: string) {
    this.tutorijali = [];
    if (route.includes('racuni')) {
      //tutorijali = this._racunTutorialsService.getTutorials(route);

      // this._subs.add(this._racunTutorialsService.getTutorials2(route).subscribe(tutorials => {
      //           this.tutorijali = tutorials;

      // }));

      this._subs.add(
        this._racunTutorialsService
          .getTutorials(this._router.url)
          .subscribe((tutorials) => {
            this.tutorijali = tutorials;
          })
      );
    }
    // else if(route.includes('banka')){
    //    tutorijali = this._bankaTutorialsService.getTutorials(route);
    //    if (tutorijali !== null) {
    //      this.tutorijali = tutorijali;
    //    }
    // }

    // else if(route.includes('robno')){
    //   tutorijali = this._robnoTutorialsService.getTutorials(route);
    //   if (tutorijali !== null) {
    //     this.tutorijali = tutorijali;
    //   }
    // }

    // else if(route.includes('stranke')){
    //   tutorijali = this._strankeTutorialsService.getTutorials(route);
    //   if (tutorijali !== null) {
    //     this.tutorijali = tutorijali;
    //   }
    // }
  }

  private routeChange() {
    this._subs.add(
      this._router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.loadTutorijals(event.url);
        }
      })
    );
  }

  // private getTutorials() {
  //  this.tutorijali.push(this._joyrideService.getTutorials());
  // }

  private prepareUserInfo() {
    const userData = this._authService.getUserData;
    const element = document.querySelector('.profile-image');
    const height = document.getElementById('avatar-initials')?.offsetHeight;
    this.name = userData.fullName;
    this.email = userData.email;
    const initials =
      userData.fullName.split(' ')[0].charAt(0).toUpperCase() +
      userData.fullName.split(' ')[1].charAt(0).toUpperCase();

    const charIndex = initials.charCodeAt(0) - 65;
    const colorIndex = charIndex % 19;
    const stylle = `background-color: ${colors[colorIndex]};
    border-radius: 10px;
    width: ${height}px;
    height: ${height}px;
    color: #FFF;
    text-align: center;
    line-height: ${height}px;`;

    if (element) {
      element.setAttribute('style', stylle);
      element.innerHTML = initials;
    }

    this.korisnikTenantAccesses$ = this._coreService.getKorisnikTenantAccesses(
      userData.email
    );

    this.isTrial = this._authService.getIsTrial;
    this.subDaysLeftText = this._authService.getSubDaysLeftText;
  }

  private _loadNotifications() {
    if (!this.filters) {
      return;
    }

    this._subs.add(
      this._notificationClient
        .getNotifikacijaKorisnikaList(this.filters)
        .subscribe((res) => {
          this._notificationService.setTopbarNotifications(
            res.data
          );
        })
    );
  }

  private _detectPageRefresh() {
    this._subs.add(
      this._router.events
        .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
        .subscribe((event) => {
          this.shouldDisplayFiskalnaKasaStavkeRacunaTitle =
            event.url === this.maloprodaja_unos_url;
        })
    );
  }

  private _notificationsSub() {
    this._subs.add(
      this._notificationService.getTopbarNotifications.subscribe((res) => {
        this.notifikacijeKorisnika = res;
      })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
    //this._sefService.stopSefHealthCheck();
  }
}
